import React, { useEffect, useState } from "react";
import { Transition } from "semantic-ui-react";
import "./AcercaDeNosotros.scss";

export function AcercaDeNosotros() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0 });
    setVisible(true);
  }, []);

  return (
    <div className="acercade-page">
      <Transition animation="fade down" duration={800} visible={visible}>
        <div>
          <h2 className="tituloPage">ACERCA DE LA UNIDAD DE DOCENCIA</h2>
          <p className="descripcionPage">
            La <b>Unidad de Docencia</b> integra la{" "}
            <b>Subdirección Provincial de Formación y Capacitación</b>, de la
            <b> Dirección Provincial de Capital Humano</b> del
            <b> Ministerio de Salud de la Provincia de Jujuy</b>.
          </p>
        </div>
      </Transition>

      {/* ETAPA 1 */}
      <div className="devpage-content-center">
        <Transition animation="scale" duration={800} visible={visible}>
          <div className="jornada-stage stage-noticia">
            <p className="jornada-stage-title">NUESTRO OBJETIVO</p>

            <p className="jornada-stage-desc">
              Es{" "}
              <b>
                contribuir con el desarrollo de una estrategia integral de
                capacitación
              </b>
              , orientada a las{" "}
              <b>mejoras de servicios y a la calidad de atención de la salud</b>{" "}
              fortaleciendo la educación permanente de su capital humano{" "}
              <b>
                con el propósito de generar sinergia y articulación entre
                políticas y programas
              </b>
              , como así mismo evitar acciones aisladas y/o descontextualizadas,
              en el marco del <b>PLAN ESTRATÉGICO II</b>.
            </p>
          </div>
        </Transition>

        {/* ETAPA 2 */}
        <Transition animation="scale" duration={800} visible={visible}>
          <div className="jornada-stage stage-noticia">
            <p className="jornada-stage-title">
              OBJETIVO DE LA AGENDA ÚNICA DE CAPACITACIÓN
            </p>

            <p className="jornada-stage-desc">
              La <b>Subdirección de Formación y Capacitación</b> a través de la{" "}
              <b>Unidad de Docencia</b> implementa la{" "}
              <b>Agenda Única de Capacitaciones</b> con el fin de acompañar las{" "}
              <b>distintas áreas y programas del Ministerio de Salud</b> con el
              objetivo de <b>fortalecer los equipos de salud</b>, desde la
              capacitación continua para dar{" "}
              <b>respuesta a las necesidades de los servicios</b>. La{" "}
              <b>Agenda Única de Capacitaciones</b> técnico-pedagógicas{" "}
              <b>
                abarca tanto las propuestas y programas de capacitación
                presenciales, semipresenciales y en línea
              </b>
              , dado el importante desarrollo que han tenido en los últimos
              tiempos las tecnologías de la información y la comunicación para
              el aprendizaje.
            </p>
          </div>
        </Transition>
      </div>
    </div>
  );
}
